import React from 'react'

function UserPermission({ setModelToggle }) {
    return (
        <div>UserPermission</div>
    )
}

export default UserPermission